export default "__VITE_ASSET__Tnt5O0sj__"